import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { environment } from '@envs/environment';
import { LoaderComponent } from '@core/components/loader/loader.component';
import { ToasterComponent } from '@core/components/toaster/toaster.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, LoaderComponent, ToasterComponent],
  templateUrl: './app.component.html',
})
export class AppComponent {
  title = 'BC Connect';

  constructor() {
    (window as any).versionDate = environment.versionDate;
  }
}
